var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.981 0c.271-.001.53.097.72.272a.87.87 0 010 1.312L2.46 9.998l9.243 8.414a.87.87 0 010 1.311c-.19.177-.45.277-.72.277-.272 0-.532-.1-.72-.277l-9.964-9.07a.87.87 0 010-1.311l9.963-9.07c.19-.175.45-.273.72-.272z",
    fill: "#484848",
    fillRule: "nonzero"
  })));
}

export default SvgArrowLeft;